import StylesPanel from '../forms/StylesPanel.jsx';
import { useEffect, useState } from 'react';
import useBusinessPostApi from '../../lib/useBusinessPostApi.js';
import { useDebounce } from '@uidotdev/usehooks';
import { useInvoiceStylesQuery, setInvoiceStylesQuery } from '~/lib/Queries';
import { ObjectTypes } from '~/lib/ObjectTypes.js';
import { getBusinessId } from '~/lib/Api';

const InvoiceStylesPanel = ({ isOpen, onClose }) => {
    const { data, isLoading } = useInvoiceStylesQuery();
    const { save, isSaving } = useBusinessPostApi(`/invoices/styles`);
    const [styles, setStyles] = useState(data?.styles || {});
    const debouncedStyles = useDebounce(styles, 500);

    useEffect(() => {
        setStyles(data?.styles || {});
    }, [JSON.stringify(data?.styles)]);

    useEffect(() => {
        if (!data) {
            // Don't set data to nothing!
            return;
        }

        // Update query cache
        setInvoiceStylesQuery({
            styles: styles,
        });

        // Save to backend
        save({
            styles: styles,
        }).then(results => {
            setInvoiceStylesQuery(results);
        });
    }, [JSON.stringify(debouncedStyles)]);

    return (
        <StylesPanel
            isOpen={isOpen}
            onClose={onClose}
            styles={styles}
            setStyles={setStyles}
            objectId={getBusinessId()}
            objectType="invoicebusiness"
            title="Invoice Styles"
            type={ObjectTypes.INVOICE}
        />
    );
};

export default InvoiceStylesPanel;

